import React from 'react';

/** Logo oficial en morado, para fondos claros. */
export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/dj1w16LYErTePdEPPkDpzG/4.png';

/** Logo oficial en blanco, para fondos oscuros. */
export const LOGO_URL_LIGHT = 'https://cdn.magicpatterns.com/uploads/4EzSi3yusiC8A5Pk9r6fr5/INK_PNG.png';
interface LogoProps {
  /** 'dark' usa el logo morado sobre fondos claros; 'light' usa la versión blanca sobre morado. */
  tone?: 'dark' | 'light';
  className?: string;
}
export function Logo({
  tone = 'dark',
  className = ''
}: LogoProps) {
  const isLight = tone === 'light';
  return <span className={`inline-flex items-center ${isLight ? 'h-11 sm:h-12' : 'h-10 sm:h-11'}`} data-id="element-193" data-mp="dspki0t5rb2a">
      <img src={isLight ? LOGO_URL_LIGHT : LOGO_URL} alt="Inkova Business Consulting & Creation" className={`h-full w-auto object-contain ${className}`} data-id="element-194" data-mp="ht8dhy6sen62" />
    </span>;
}